module.exports = __webpack_public_path__ + "images/right-1171f4d339ff44e484da477c7ba4f105.png";